import * as React from 'react';
import { makeStyles, withStyles } from '@mui/styles';
import { Stepper, Step, StepLabel, StepConnector, StepIconProps } from '@mui/material';
import clsx from 'clsx';

export interface PhaseStepperProps {
    steps: string[];
    activeStep: number;
    icons: React.ReactElement[];
}

const CustomConnector = withStyles({
    alternativeLabel: {
        top: 22,
    },
    active: {
        '& $line': {
            backgroundImage: 'linear-gradient( 95deg, #139872 0%, #00534C 100%)',
        },
    },
    completed: {
        '& $line': {
            backgroundImage: 'linear-gradient( 95deg, #139872 0%, #00534C 100%)',
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
})(StepConnector);

const useStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 50,
        height: 50,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        backgroundImage: 'linear-gradient( 136deg, #139872 0%, #00534C 100%)',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    completed: {
        backgroundImage: 'linear-gradient( 136deg, #139872 0%, #00534C 100%)',
    },
});

const StepIcon: React.FC<StepIconProps & { icons: React.ReactElement[] }> = ({ active, completed, icon, icons }) => {
    const classes = useStepIconStyles();

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}
        >
            {icons[Number(icon) - 1]}
        </div>
    );
};

const PhaseStepper: React.FC<PhaseStepperProps> = ({ steps, activeStep, icons }) => {
    return (
        <Stepper activeStep={activeStep} alternativeLabel connector={<CustomConnector />}>
            {steps.map((label, index) => (
                <Step key={label}>
                    <StepLabel StepIconComponent={(props) => <StepIcon {...props} icons={icons} />}>
                        {label}
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    );
};

export default PhaseStepper;